import { Box, Flex, Text } from '@chakra-ui/layout'
import { Switch } from '../../components/Switch'
import { Input } from '@chakra-ui/input'
import { InputInnovationDoubleDate } from './components/InputInnovationDoubleDate'
import { InputInnovationText } from './components/InputInnovationText'
import { Button } from './components/Button'
import { InputInnovationSelect } from './components/InputInnovationSelect'
import { useEffect, useState } from 'react'
import { FaCheckCircle } from 'react-icons/fa'
import { Date as DateComponent } from '../../components/Date'
import { useValorVerba } from '../../hooks/useValorVerba'
import { Icon } from '@chakra-ui/icon'
import { useMediaQuery } from '@chakra-ui/react'
import { useFunilVendas } from '../../hooks/useFunilVendas'
import { DropdownCheckbox } from './components/DropdownCheckbox'
import { useSearchParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { IoMdClose } from 'react-icons/io'
import { errorHandler } from '../../services/errorHandlerPropostas'

export function Filtro({ refetch, setParameters }) {
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    control,
    formState: { errors },
    setError,
  } = useForm()
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')
  const { listaValorVerba, refetchValorVerba } = useValorVerba()
  const { listaFunilVendas } = useFunilVendas()

  const [searchParams, setSearchParams] = useSearchParams()

  // Função para atualizar a URL com os parâmetros
  function updateUrlParams(params) {
    const currentParams = Object.fromEntries(searchParams.entries())

    // Combinar parâmetros existentes com novos
    const updatedParams = { ...currentParams }

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        updatedParams[key] = value
      } else {
        // Remover parâmetros vazios
        delete updatedParams[key]
      }
    })

    setSearchParams(updatedParams)
  }

  async function onSubmit(data) {
    const isValid = errorHandler(data, setError)

    if (!isValid) return

    let parameters = {
      cliente: data.tipo_cliente,
      data_inicio: data.de,
      data_fim: data.ate,
      numero_proposta: data.numero_proposta,
      prazos: prazos.map((item) => item.value).join(','),
      funil_vendas: funilDeVendas.map((item) => item.value).join(','),
      valor_verba: verbasSelected.map((item) => item.value).join(','),
      proposta_especial: data.proposta_especial,
      desconto: data.desconto,
      cliente_especial: data.cliente_especial,
      retornar_em: data.retornar_em,
      retornar_fim: data.retornar_fim,
      origem_contato: origemSelected.map((item) => item.value).join(','),
      valida_layout: data.layout ? 'S' : 'N',
    }

    if (searchParams.get('propostas_perdidas') === 's') {
      parameters.propostas_perdidas = data.retornar_em
    }

    // Salvar todos os parâmetros na URL apenas quando clicar em atualizar
    updateUrlParams(parameters)

    setParameters(parameters)
    refetch()
  }

  useEffect(() => {
    const params = Object.fromEntries(searchParams)

    if (params) {
      setParameters(params)
    }
  }, [searchParams, setParameters])

  // Inicializar estados com valores da URL
  const [funilDeVendas, setFunilDeVendas] = useState(
    searchParams.get('funil_vendas')
      ? searchParams
          .get('funil_vendas')
          .split(',')
          .map((item) => {
            return listaFunilVendas.find((f) => f.value.toString() === item) || { value: parseInt(item), label: item }
          })
      : []
  )

  const [verbasSelected, setVerbasSelected] = useState(
    searchParams.get('valor_verba')
      ? searchParams
          .get('valor_verba')
          .split(',')
          .map((item) => {
            return listaValorVerba.find((v) => v.value.toString() === item) || { value: parseInt(item), label: item }
          })
      : []
  )

  const [origemSelected, setOrigemSelected] = useState(
    searchParams.get('origem_contato')
      ? searchParams
          .get('origem_contato')
          .split(',')
          .map((item) => {
            const origens = [
              { value: 1, label: 'SITE' },
              { value: 2, label: 'WHATSAPP' },
              { value: 3, label: 'VENDEDOR' },
              { value: 4, label: 'ATENDIMENTO' },
            ]
            return origens.find((o) => o.value.toString() === item) || { value: parseInt(item), label: item }
          })
      : []
  )

  const [prazos, setPrazos] = useState(
    searchParams.get('prazos')
      ? searchParams
          .get('prazos')
          .split(',')
          .map((item) => {
            return { value: parseInt(item), label: `${item} dias` }
          })
      : []
  )

  function handleFunilDeVendas(value) {
    let newFunilDeVendas
    if (funilDeVendas.some((item) => item.value === value.value)) {
      newFunilDeVendas = funilDeVendas.filter((item) => item.value !== value.value)
    } else {
      newFunilDeVendas = [...funilDeVendas, value]
    }

    setFunilDeVendas(newFunilDeVendas)
    // Não atualiza a URL aqui, apenas o estado interno
  }

  function handleVerbasSelected(value) {
    let newVerbasSelected
    if (verbasSelected.some((item) => item.value === value.value)) {
      newVerbasSelected = verbasSelected.filter((item) => item.value !== value.value)
    } else {
      newVerbasSelected = [...verbasSelected, value]
    }

    setVerbasSelected(newVerbasSelected)
    // Não atualiza a URL aqui, apenas o estado interno
  }

  function handleOrigemSelected(value) {
    let newOrigemSelected
    if (origemSelected.some((item) => item.value === value.value)) {
      newOrigemSelected = origemSelected.filter((item) => item.value !== value.value)
    } else {
      newOrigemSelected = [...origemSelected, value]
    }

    setOrigemSelected(newOrigemSelected)
    // Não atualiza a URL aqui, apenas o estado interno
  }

  function handlePrazos(value) {
    let newPrazos
    if (prazos.some((item) => item.value === value.value)) {
      newPrazos = prazos.filter((item) => item.value !== value.value)
    } else {
      newPrazos = [...prazos, value]
    }

    setPrazos(newPrazos)
    // Não atualiza a URL aqui, apenas o estado interno
  }

  async function clearAllFilters() {
    setValue('numero_proposta', '')
    setValue('de', '')
    setValue('ate', '')
    setValue('proposta_especial', false)
    setValue('desconto', false)
    setValue('cliente_especial', false)
    setValue('retornar_em', '')
    setValue('layout', false)
    setValue('retornar_fim', '')

    setOrigemSelected([])
    setFunilDeVendas([])
    setVerbasSelected([])
    setPrazos([])

    // Preservar apenas parâmetros de paginação
    const limit = searchParams.get('limit')
    const page = searchParams.get('page')

    // Limpar URL mantendo apenas paginação
    const newParams = {}
    if (limit) newParams.limit = limit
    if (page) newParams.page = page

    setSearchParams(newParams)
    setParameters(newParams)

    refetchValorVerba()
    refetch()
  }

  const proposta_especial = watch('proposta_especial')
  const desconto = watch('desconto')
  const cliente_especial = watch('cliente_especial')
  const layout = watch('layout')
  const retornar_em = watch('retornar_em')
  const retornar_fim = watch('retornar_fim')
  const numero_proposta = watch('numero_proposta')
  const de = watch('de')
  const ate = watch('ate')
  const tipo_cliente = watch('tipo_cliente')

  // Removidos os useEffect que atualizavam a URL a cada alteração dos campos
  // Agora a URL será atualizada apenas quando o usuário clicar em "Atualizar"

  // Atualizar campos de formulário quando URL mudar
  useEffect(() => {
    setValue('proposta_especial', searchParams.get('proposta_especial') === 'true')
    setValue('desconto', searchParams.get('desconto') === 'true')
    setValue('cliente_especial', searchParams.get('cliente_especial') === 'true')
    setValue('layout', searchParams.get('valida_layout') === 'S')
    setValue('retornar_em', searchParams.get('retornar_em') || '')
    setValue('retornar_fim', searchParams.get('retornar_fim') || '')
    setValue('numero_proposta', searchParams.get('numero_proposta') || '')
    setValue('de', searchParams.get('data_inicio') || '')
    setValue('ate', searchParams.get('data_fim') || '')
    setValue('tipo_cliente', searchParams.get('cliente') || '')
  }, [searchParams, setValue])

  return (
    <Box as="form" onSubmit={handleSubmit(onSubmit)}>
      <Flex alignItems="center" justifyContent="space-between" w="100%" maxW="1339px" mx="auto" gap={2}>
        <InputInnovationSelect
          maxW="320px"
          flex={1}
          options={[
            { label: 'Nome do Cliente', value: 'NomeCliente' },
            { label: 'CPF/CNPJ', value: 'CpfCnpj' },
            { label: 'Código do Cliente', value: 'CodigoCliente' },
            { label: 'E-mail', value: 'Email' },
          ]}
          control={control}
          name="tipo_cliente"
          error={errors.tipo_cliente}
        />

        <InputInnovationText maxW="170px" w="100%" label="Nº Proposta" name="numeroProposta" {...register('numero_proposta')} />
        <InputInnovationDoubleDate maxW="308px" w="100%">
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            De:
          </Text>
          <Input
            type="date"
            border="0"
            sx={{
              padding: '10px',
            }}
            padding="0"
            outline="0"
            boxShadow="0"
            fontSize="13px"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            {...register('de')}
          />
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            Até:
          </Text>
          <Input
            type="date"
            sx={{
              padding: '10px',
            }}
            border="0"
            padding="0"
            outline="0"
            fontSize="13px"
            boxShadow="0"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            {...register('ate')}
          />
        </InputInnovationDoubleDate>

        <DropdownCheckbox
          maxW={isLargerThan1366 ? '220px' : '300px'}
          h="29px"
          label="Funil de Vendas:"
          setValue={handleFunilDeVendas}
          quantitySelected={funilDeVendas.length}
          options={listaFunilVendas}
          defaultValue={searchParams
            .get('funil_vendas')
            ?.split(',')
            ?.map((item) => parseInt(item))}
          clearAll={() => {
            setFunilDeVendas([])
          }}
        />

        <DropdownCheckbox
          maxW="130px"
          h="29px"
          label="Origem:"
          setValue={handleOrigemSelected}
          quantitySelected={origemSelected.length}
          options={[
            {
              value: 1,
              label: 'SITE',
            },
            {
              value: 2,
              label: 'WHATSAPP',
            },
            {
              value: 3,
              label: 'VENDEDOR',
            },
            {
              value: 4,
              label: 'ATENDIMENTO',
            },
          ]}
        />

        <DropdownCheckbox
          maxW="130px"
          h="29px"
          label="Verba:"
          setValue={handleVerbasSelected}
          quantitySelected={verbasSelected.length}
          options={listaValorVerba}
          defaultValue={searchParams
            .get('valor_verba')
            ?.split(',')
            ?.map((item) => parseInt(item))}
        />
      </Flex>
      <Flex alignItems="end" justifyContent="space-between" w="full" gap={2} mt={1} maxW="1339px" mx="auto">
        <Switch
          icon={<Icon as={FaCheckCircle} color="#378BBF" fontSize="25px" />}
          label="Proposta Importante"
          {...register('proposta_especial')}
          isChecked={proposta_especial}
        />
        <Switch icon={<Icon as={FaCheckCircle} color="#37bfa8" fontSize="25px" />} label="Layout" {...register('layout')} isChecked={layout} />
        <Switch icon={<Icon as={FaCheckCircle} color="#76BF37" fontSize="25px" />} label="Desconto" {...register('desconto')} isChecked={desconto} />
        <Switch
          icon={<Icon as={FaCheckCircle} color="#FFA200" fontSize="25px" />}
          label="Cliente especial"
          {...register('cliente_especial')}
          isChecked={cliente_especial}
        />

        <Flex flexDir="column">
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            {searchParams.get('propostas_perdidas') === 's' ? 'Perdido em:' : 'Retornar em:'}
          </Text>
          <Flex alignItems="center" gap={1}>
            <DateComponent label="de" h="29px" {...register('retornar_em')} />
            <DateComponent label="até" h="29px" {...register('retornar_fim')} />
          </Flex>
        </Flex>
        <DropdownCheckbox
          maxW="100px"
          h="29px"
          label="Prazos:"
          setValue={handlePrazos}
          quantitySelected={prazos?.length}
          options={[
            { label: '1 dia', value: 1 },
            { label: '2 dias', value: 2 },
            { label: '3 dias', value: 3 },
            { label: '4 dias', value: 4 },
            { label: '5 dias', value: 5 },
            { label: '6 dias', value: 6 },
            { label: '7 dias', value: 7 },
            { label: '8 dias', value: 8 },
            { label: '9 dias', value: 9 },
            { label: '10 dias', value: 10 },
          ]}
          defaultValue={searchParams
            .get('prazos')
            ?.split(',')
            ?.map((item) => parseInt(item))}
        />

        <Button maxW="181px" w="100%" loadingText="Atualizando..." type="submit">
          Atualizar
        </Button>
        <Button
          bgColor="transparent"
          color="#378bbf"
          border="1px solid #378BBF"
          maxW="131px"
          w="100%"
          onClick={clearAllFilters}
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={2}
          type="reset"
        >
          <IoMdClose /> Limpar
        </Button>
      </Flex>
    </Box>
  )
}
